import { LNotification } from "@lib/abpUtility"
import { notifySuccess } from "@lib/helper"
import type {
  AgencyMasterGroupAssignUserInput,
  AgencyMasterGroupCreateInput,
  AgencyMasterGroupDto,
  AgencyMasterGroupGetAllParams,
  AgencyMasterGroupUpdateInput,
  AgencyMasterGroupUserDto,
} from "@models/agencyMasterGroup/agencyMasterGroupModel"
import type { PagedResultDto } from "@services/dto/pagedResultDto"
import http from "@services/httpService"

const basePath = "api/services/app/AgencyMasterGroup"

class AgencyMasterGroupService {
  public async create(
    body: AgencyMasterGroupCreateInput
  ): Promise<AgencyMasterGroupDto> {
    const res = await http.post(`${basePath}/Create`, body)
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("SAVING_SUCCESSFULLY")
    )
    return res.data.result
  }

  public async update(
    body: AgencyMasterGroupUpdateInput
  ): Promise<AgencyMasterGroupDto> {
    const res = await http.put(`${basePath}/Update`, body)
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("SAVING_SUCCESSFULLY")
    )
    return res.data.result
  }

  public async delete(id: number): Promise<void> {
    await http.delete(`${basePath}/Delete`, { params: { id } })
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("UPDATE_SUCCESSFULLY")
    )
  }

  public async get(id: number): Promise<AgencyMasterGroupDto> {
    const res = await http.get(`${basePath}/Get`, { params: { id } })
    return res.data.result
  }

  public async getAll(
    params: AgencyMasterGroupGetAllParams
  ): Promise<PagedResultDto<AgencyMasterGroupDto>> {
    const res = await http.get(`${basePath}/GetAll`, { params })
    return res.data.result
  }

  public async assignUser(body: AgencyMasterGroupAssignUserInput): Promise<void> {
    await http.post(`${basePath}/AssignUser`, body)
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("SAVING_SUCCESSFULLY")
    )
  }

  /** Gán lần lượt, một toast khi hoàn thành (tránh popup kép khi multi-select). */
  public async assignManyUsers(
    assignments: AgencyMasterGroupAssignUserInput[]
  ): Promise<void> {
    if (!assignments.length) return
    for (const body of assignments) {
      await http.post(`${basePath}/AssignUser`, body)
    }
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("SAVING_SUCCESSFULLY")
    )
  }

  public async removeUser(groupId: number, userId: number): Promise<void> {
    await http.post(`${basePath}/RemoveUser`, null, {
      params: { groupId, userId },
    })
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("UPDATE_SUCCESSFULLY")
    )
  }

  public async getGroupUsers(groupId: number): Promise<AgencyMasterGroupUserDto[]> {
    const res = await http.get(`${basePath}/GetGroupUsers`, {
      params: { groupId },
    })
    return res.data.result ?? []
  }

  public async getManagedUsers(): Promise<AgencyMasterGroupUserDto[]> {
    const res = await http.get(`${basePath}/GetManagedUsers`)
    return res.data.result ?? []
  }
}

export default new AgencyMasterGroupService()
